export enum ObjectType {
    All = 0,
    CertificateList = 1,
    CertificationPlan = 2,
    CPRequirement = 3,
    User = 4,
    CPEnrollmentRequest = 5,
    Questionnaire = 7
    //UserUpdate = 6,
  }